<div class="select-week-dialog">
  <div class="dialog-header">
    <h2>Select Week</h2>
    <button mat-icon-button (click)="onCancel()" class="close-btn">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="dialog-content">
    <div class="filter-row">
      <!-- Year Selector -->
      <div class="filter-field" style="max-width: 250px;">
        <label>Year</label>
        <mat-form-field appearance="outline" class="select-field">
          <mat-icon matPrefix>calendar_today</mat-icon>
          <mat-select [(value)]="selectedYear" (selectionChange)="onYearChange()">
            <mat-option *ngFor="let y of years" [value]="y.year">
              {{ y.display_year }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="weeks-section">
      <h3>Weeks in {{ getSelectedYearDisplay() }}</h3>
      
      <div class="weeks-list" *ngIf="filteredWeeks.length > 0; else noWeeks">
        <div 
          *ngFor="let week of filteredWeeks" 
          class="week-row" 
          [class.selected]="selectedWeek && selectedWeek.week_no === week.week_no && selectedWeek.year === week.year"
          [id]="(selectedWeek && selectedWeek.week_no === week.week_no && selectedWeek.year === week.year) ? 'selected-week-row' : ''"
          (click)="selectWeek(week)"
        >
          <div class="week-radio">
            <mat-radio-button 
              [checked]="selectedWeek && selectedWeek.week_no === week.week_no && selectedWeek.year === week.year"
              (click)="$event.stopPropagation(); selectWeek(week)"
              color="primary">
            </mat-radio-button>
          </div>
          
          <div class="week-title-col">
            <span class="week-name">Week {{ week.week_no }}</span>
            <span class="week-range">{{ formatWeekRange(week) }}</span>
          </div>

          <div class="date-col">
            <span class="date-val">{{ formatDate(week.start_date) }}</span>
            <span class="date-label">Start Date</span>
          </div>

          <div class="date-col">
            <span class="date-val">{{ formatDate(week.end_date) }}</span>
            <span class="date-label">End Date</span>
          </div>

          <div class="badge-col">
            <span class="current-badge" *ngIf="isCurrentWeek(week)">Current</span>
          </div>
        </div>
      </div>

      <ng-template #noWeeks>
        <div class="no-weeks-message">
          <mat-icon>info_outline</mat-icon>
          <p>No weeks defined for {{ getSelectedYearDisplay() }}</p>
        </div>
      </ng-template>
    </div>
  </mat-dialog-content>

  <div class="dialog-actions">
    <button mat-button (click)="onCancel()" class="cancel-btn">CANCEL</button>
    <button mat-flat-button color="primary" [disabled]="!selectedWeek" (click)="onApply()" class="apply-btn">APPLY</button>
  </div>
</div>
